import * as React from 'react';
import { Suspense } from 'react';
import lazyRetry from '../../components/lazyRetry';
import { MonacoLoading } from '../elements/editors/monaco/MonacoLoading';
import * as monaco from 'monaco-editor';
export interface TransformDSLEditorProps {
  value: string;
  isReadOnly?: boolean;
  index: number;
  expandedRecipeIndex?: number;
  monacoOptions?: monaco.editor.IStandaloneEditorConstructionOptions;
  onRun?: () => void;
  onNewRule?: () => void;
  onChange?: (value: string) => void;
  onFocusRule?: (index: number) => void;
  onNavigateRules?: (direction: number) => void;
  onBlurOutside?: () => void;
}

const LoadableEditor = lazyRetry(() => import('./TransformDSLEditor'), 'TransformDSLEditor');

const LoadableTransformDSLEditor = (props: TransformDSLEditorProps) => (
  <Suspense fallback={<MonacoLoading />}>
    <LoadableEditor {...props} />
  </Suspense>
);

export default LoadableTransformDSLEditor;
